import React from "react";
import {withRouter} from 'react-router-dom';

import axios from 'axios';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Button from "components/CustomButtons/Button.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { API_ROOT, STRIPE_CONNECT_URL, STRIPE_CLIENT_ID, CREDIT_CARD_PROCESSOR, HOST_ADDRESS } from 'api-config';
import { getApiHeaders, parsePhoneResponse } from "../../assets/helpers/apiHelper";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  ...customSelectStyle,
  ...regularFormsStyle
};

class CreditCardProcessorSignup extends React.Component {
  constructor(props) {
    super(props);
    var providerUuid = sessionStorage.getItem('userUuid');
    if (this.props.providerUuid) {
      providerUuid = this.props.providerUuid
    }

    this.state = {
      providerUuid: providerUuid,
      showCreditCardProcessingAccountSetup: false,
      showCreditCardProcessorNeededButton: false
    };
  }


  componentDidMount(){
    this._isMounted = true;
    if (this.state.getCurrentSettings) {
      this.creditCardProcessorSignUpGetToken()
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  creditCardProcessorSignUpGetToken() {
    axios.get(`${API_ROOT}/csrfToken/?type=` + CREDIT_CARD_PROCESSOR, { headers: getApiHeaders() })
      .then(res => this.creditCardProcessorSignUpGetAccountInfo({ responseMessage: res.data }));

  }

  creditCardProcessorSignUpGetAccountInfo(tokenRes) {
    const token = tokenRes.responseMessage.token
    axios.get(`${API_ROOT}/provider/?providerUuid=` + this.state.providerUuid + `&includeInactive=1&returnHidden=1`, { headers: getApiHeaders() })
      .then(res => this.openCreditCardProcessorSignUp({ responseMessage: res.data }, token));

  }

  openCreditCardProcessorSignUp(accountInfoRes, token) {
    const accountInfo = accountInfoRes.responseMessage[0]
    // get the phone number
    const phoneArray = parsePhoneResponse(JSON.parse(accountInfo['phone']))
    const redirect_uri = HOST_ADDRESS + '/creditCardProcessorSignupFinalize'
    var params = '&client_id=' + STRIPE_CLIENT_ID
    params += '&state=' + token
    params += '&redirect_uri=' + redirect_uri
    params += '&stripe_user[email]=' + accountInfo['email']
    params += '&stripe_user[business_name]=' + accountInfo['name']
    params += '&stripe_user[phone_number]=' + phoneArray['phone']
    params += '&stripe_user[street_address]=' + accountInfo['address1']
    params += '&stripe_user[city]=' + accountInfo['city']
    params += '&stripe_user[state]=' + accountInfo['state']
    params += '&stripe_user[zip]=' + accountInfo['zip']
    params += '&stripe_user[country]=US'

    const url = STRIPE_CONNECT_URL + params
    window.location.href = url
  }

  render() {
    return (
      <div>
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={12}>
            <p>To allow credit card payments, you need to set up an account with Stripe, who we have partnered with for credit card processing.</p>
            <p>The setup takes only a few minutes.</p>
            <p>Please click the button to set up your account. If you are not taken to the page to sign up for credit card processing,
              be sure to have popups enabled for {HOST_ADDRESS} or allow the window that opens when you click the button.</p>
            <Button onClick={this.creditCardProcessorSignUpGetToken.bind(this)} color="cirrusBlue">
              set up credit card account
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withRouter(withStyles(style)(CreditCardProcessorSignup));
